var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDHeatingDynamicRoomlevel = function SvgDHeatingDynamicRoomlevel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 322.99,
    y: 136,
    width: 10,
    height: 28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.99,
    y: 149,
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "327.98 151.01 335.13 163.5 320.85 163.5 327.98 151.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.98,152.02l6.29,10.98h-12.55s6.26-10.98,6.26-10.98M327.98,150l-7.98,14h16s-8.01-14-8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "320.85 136.51 335.13 136.5 327.98 148.99 320.85 136.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.26,137l-6.29,10.98-6.26-10.98h12.55M335.99,136h-16s7.98,14,7.98,14l8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 307,
    cy: 150,
    r: 11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,140c5.51,0,10,4.49,10,10s-4.48,10-10,10-10-4.49-10-10,4.48-10,10-10M307,139c-6.07,0-11,4.92-11,11s4.92,11,11,11,11-4.92,11-11-4.92-11-11-11h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M309.41,147.15v5.69h-.98v-1.87s.1-2.5.1-2.5l-1.68,4.38h-.71s-1.68-4.38-1.68-4.38l.1,2.51v1.87h-.98v-5.69h1.28s1.64,4.36,1.64,4.36l1.64-4.36h1.28Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 322.99,
    y: 168,
    width: 10,
    height: 28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "327.98 183.01 335.13 195.49 320.85 195.5 327.98 183.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.98,184.02l6.29,10.97h-12.55s6.26-10.97,6.26-10.97M327.98,182l-7.98,14h16s-8.01-14-8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "320.85 168.51 335.13 168.5 327.98 180.99 320.85 168.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.26,169l-6.29,10.98-6.26-10.98h12.55M335.99,168h-16s7.98,14,7.98,14l8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 176,
    width: 5,
    height: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,177v10h-3v-10h3M345,176h-5v12h5v-12h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 176,
    width: 5,
    height: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,177v10h-3v-10h3M350,176h-5v12h5v-12h0Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "343 176 342 176 342 166.5 328 166.5 328 165.5 343 165.5 343 176"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348 176 347 176 347 134.5 327.97 134.5 327.97 133.5 348 133.5 348 176"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 181,
    width: 12,
    height: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 327,
    y: 133.5,
    width: 2,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327,
    y: 164,
    width: 2,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 516.99,
    y: 136,
    width: 10,
    height: 28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 511.99,
    y: 149,
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "521.98 151.01 529.13 163.5 514.85 163.5 521.98 151.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.98,152.02l6.29,10.98h-12.55s6.26-10.98,6.26-10.98M521.98,150l-7.98,14h16s-8.01-14-8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "514.85 136.51 529.13 136.5 521.98 148.99 514.85 136.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.26,137l-6.29,10.98-6.26-10.98h12.55M529.99,136h-16s7.98,14,7.98,14l8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 501,
    cy: 150,
    r: 11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501,140c5.51,0,10,4.49,10,10s-4.48,10-10,10-10-4.49-10-10,4.48-10,10-10M501,139c-6.07,0-11,4.92-11,11s4.92,11,11,11,11-4.92,11-11-4.92-11-11-11h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M503.41,147.15v5.69h-.98v-1.87s.1-2.5.1-2.5l-1.68,4.38h-.71s-1.68-4.38-1.68-4.38l.1,2.51v1.87h-.98v-5.69h1.28s1.64,4.36,1.64,4.36l1.64-4.36h1.28Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 516.99,
    y: 168,
    width: 10,
    height: 28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "521.98 183.01 529.13 195.49 514.85 195.5 521.98 183.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.98,184.02l6.29,10.97h-12.55s6.26-10.97,6.26-10.97M521.98,182l-7.98,14h16s-8.01-14-8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "514.85 168.51 529.13 168.5 521.98 180.99 514.85 168.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.26,169l-6.29,10.98-6.26-10.98h12.55M529.99,168h-16s7.98,14,7.98,14l8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 534,
    y: 176,
    width: 5,
    height: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538,177v10h-3v-10h3M539,176h-5v12h5v-12h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 539,
    y: 176,
    width: 5,
    height: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543,177v10h-3v-10h3M544,176h-5v12h5v-12h0Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "537 176 536 176 536 166.5 522 166.5 522 165.5 537 165.5 537 176"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "542 176 541 176 541 134.5 521.97 134.5 521.97 133.5 542 133.5 542 176"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522,
    y: 181,
    width: 12,
    height: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 521,
    y: 133.5,
    width: 2,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 521,
    y: 164,
    width: 2,
    height: 4
  })))));
};
export default SvgDHeatingDynamicRoomlevel;